/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 値型： - TEXT:文字 - NUMBER:数値 - WHOLE_NUMBER:ゼロを含む正の整数 - DATE:日付 - DATETIME:日付時刻 - BOOL:真偽値 - SINGLE_SELECT:区分値(単一選択) - MULTI_SELECT:区分値(複数選択) 
 * @export
 * @enum {string}
 */

export const ExtensiveAttributeValueType = {
    Text: 'TEXT',
    Number: 'NUMBER',
    WholeNumber: 'WHOLE_NUMBER',
    Date: 'DATE',
    Datetime: 'DATETIME',
    Bool: 'BOOL',
    SingleSelect: 'SINGLE_SELECT',
    MultiSelect: 'MULTI_SELECT'
} as const;

export type ExtensiveAttributeValueType = typeof ExtensiveAttributeValueType[keyof typeof ExtensiveAttributeValueType];



